export default __webpack_public_path__ + "static/media/Db_7.df9760bc.png";